import { render, staticRenderFns } from "./FocusPointGrid.vue?vue&type=template&id=6bf0861a&"
import script from "./FocusPointGrid.vue?vue&type=script&lang=ts&"
export * from "./FocusPointGrid.vue?vue&type=script&lang=ts&"
import style0 from "./FocusPointGrid.vue?vue&type=style&index=0&id=6bf0861a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports